function normalizeNewsletterCouponValue(value) {
  return (value || '').trim();
}

function syncNewsletterReturnUrls() {
  document.querySelectorAll('[data-newsletter-return-to]').forEach((input) => {
    try {
      const url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.set('customer_posted', 'true');
      input.value = `${url.pathname}${url.search}`;
    } catch (error) {}
  });
}

function shouldShowNewsletterDebugBanner() {
  try {
    const currentUrl = new URL(window.location.href);
    return currentUrl.searchParams.get('customer_posted') === 'true';
  } catch (error) {
    return false;
  }
}

function renderNewsletterDebugBanner(message) {
  return;
}

function escapeNewsletterHtml(value) {
  return (value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

const NEWSLETTER_PENDING_COUPON_STORAGE_KEY = 'newsletter-coupon-pending';
const NEWSLETTER_COUPON_REDIRECT_LOCK_KEY = 'newsletter-coupon-redirect-lock';

function buildNewsletterCouponStorageKey(email, code) {
  return `newsletter-coupon:${normalizeNewsletterCouponValue(email).toLowerCase()}:${normalizeNewsletterCouponValue(code).toUpperCase()}`;
}

function replaceNewsletterCouponTemplatePlaceholders(template, replacements) {
  return Object.entries(replacements).reduce((output, [key, value]) => (
    output.replaceAll(`{{ ${key} }}`, value)
  ), template);
}

function getNewsletterCouponCartUrl() {
  if (window.theme && window.theme.routes && window.theme.routes.cart) {
    return `${window.theme.routes.cart}.js`;
  }

  return '/cart.js';
}

function buildNewsletterCouponDiscountUrl(code) {
  return `/discount/${encodeURIComponent(code)}?redirect=%2Fcart`;
}

function setPendingNewsletterCoupon(payload) {
  try {
    window.localStorage.setItem(NEWSLETTER_PENDING_COUPON_STORAGE_KEY, JSON.stringify(payload));
  } catch (error) {}
}

function getPendingNewsletterCoupon() {
  try {
    const rawValue = window.localStorage.getItem(NEWSLETTER_PENDING_COUPON_STORAGE_KEY);
    return rawValue ? JSON.parse(rawValue) : null;
  } catch (error) {
    return null;
  }
}

function clearPendingNewsletterCoupon() {
  try {
    window.localStorage.removeItem(NEWSLETTER_PENDING_COUPON_STORAGE_KEY);
  } catch (error) {}
}

function isNewsletterCouponRedirectLocked() {
  try {
    return window.sessionStorage.getItem(NEWSLETTER_COUPON_REDIRECT_LOCK_KEY) === 'true';
  } catch (error) {
    return false;
  }
}

function lockNewsletterCouponRedirect() {
  try {
    window.sessionStorage.setItem(NEWSLETTER_COUPON_REDIRECT_LOCK_KEY, 'true');
  } catch (error) {}
}

function activatePendingNewsletterCoupon(cart) {
  const pendingCoupon = getPendingNewsletterCoupon();

  if (!pendingCoupon || !pendingCoupon.code) return;
  if (cart && cart.item_count < 1) return;
  if (isNewsletterCouponRedirectLocked()) return;
  if (window.location.pathname.startsWith('/discount/')) return;

  lockNewsletterCouponRedirect();
  clearPendingNewsletterCoupon();
  window.location.href = buildNewsletterCouponDiscountUrl(pendingCoupon.code);
}

async function fetchNewsletterCouponCart() {
  const response = await fetch(getNewsletterCouponCartUrl(), {
    headers: {
      Accept: 'application/json'
    }
  });

  if (!response.ok) throw new Error(response.status);

  return response.json();
}

class NewsletterCoupon {
  constructor(section) {
    this.section = section;
    this.modal = section.querySelector('.js-newsletter-coupon-modal');
    this.successMarker = section.querySelector('[data-newsletter-signup-success]');

    if (!this.modal || !this.successMarker) return;

    this.code = normalizeNewsletterCouponValue(this.modal.dataset.couponCode);
    this.email = normalizeNewsletterCouponValue(this.successMarker.dataset.newsletterEmail);
    this.storageKey = buildNewsletterCouponStorageKey(this.email, this.code);
    this.applyButton = this.modal.querySelector('.js-newsletter-coupon-apply');
    this.copyButtons = this.modal.querySelectorAll('.js-newsletter-coupon-copy');
    this.feedback = this.modal.querySelector('.js-newsletter-coupon-feedback');
    this.emailSubjectTemplate = this.modal.dataset.emailSubject || '';
    this.emailBodyTemplate = this.modal.dataset.emailBody || '';
    this.discountUrl = this.modal.dataset.discountUrl || buildNewsletterCouponDiscountUrl(this.code);
    this.emptyCartFeedback = this.modal.dataset.emptyCartFeedback || '';
    this.eyebrow = (this.modal.querySelector('.newsletter-coupon-modal__eyebrow') || {}).textContent || '';
    this.heading = (this.modal.querySelector('.newsletter-coupon-modal__title') || {}).textContent || '';
    this.text = (this.modal.querySelector('.newsletter-coupon-modal__text') || {}).innerHTML || '';
    this.codeLabel = (this.modal.querySelector('.newsletter-coupon-modal__label') || {}).textContent || '';
    this.subtext = (this.modal.querySelector('.newsletter-coupon-modal__subtext') || {}).textContent || '';
    this.popup = null;

    this.bindEvents();

    if (this.shouldOpenModal()) {
      this.openModal();
    }
  }

  bindEvents() {
    if (this.applyButton) {
      this.applyButton.addEventListener('click', async (event) => {
        await this.handleApplyCoupon(event);
      });
    }

    this.copyButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.markClaimed('copied');
      });
    });
  }

  shouldOpenModal() {
    if (shouldShowNewsletterDebugBanner()) {
      return true;
    }

    return Boolean(this.code && this.email);
  }

  openModal() {
    if (this.popup) return;

    const popup = document.createElement('div');
    popup.setAttribute('data-newsletter-popup', '');
    popup.innerHTML = `
      <div style="position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9998;"></div>
      <div style="position:fixed;left:50%;top:50%;transform:translate(-50%,-50%);width:min(92vw,680px);max-height:90vh;overflow:auto;background:#fff;color:#111;z-index:9999;padding:28px;border-radius:8px;box-shadow:0 30px 80px rgba(0,0,0,.22);">
        <button type="button" data-newsletter-popup-close style="position:absolute;top:10px;right:12px;background:none;border:0;font-size:28px;line-height:1;cursor:pointer;">&times;</button>
        ${this.eyebrow ? `<p style="margin:0 0 12px;font-size:12px;letter-spacing:.12em;text-transform:uppercase;opacity:.7;">${escapeNewsletterHtml(this.eyebrow)}</p>` : ''}
        <h2 style="margin:0 0 12px;font-size:32px;line-height:1.1;">${escapeNewsletterHtml(this.heading || 'Itt a kuponod')}</h2>
        ${this.text ? `<div style="margin:0 0 20px;">${this.text}</div>` : ''}
        ${this.codeLabel ? `<div style="margin-bottom:6px;font-size:12px;letter-spacing:.08em;text-transform:uppercase;opacity:.7;">${escapeNewsletterHtml(this.codeLabel)}</div>` : ''}
        <div style="display:flex;gap:10px;align-items:stretch;flex-wrap:wrap;margin-bottom:14px;">
          <div style="flex:1 1 220px;border:1px solid #ddd;padding:14px 16px;font-weight:700;letter-spacing:.08em;text-align:center;">${escapeNewsletterHtml(this.code)}</div>
          <button type="button" data-newsletter-popup-copy style="flex:0 0 auto;padding:14px 18px;background:#111;color:#fff;border:0;cursor:pointer;">Másolás</button>
        </div>
        ${this.subtext ? `<p style="margin:0 0 18px;opacity:.75;">${escapeNewsletterHtml(this.subtext)}</p>` : ''}
        <div style="display:grid;grid-template-columns:minmax(0,1fr);gap:12px;">
          <button type="button" data-newsletter-popup-apply style="padding:14px 16px;border:0;background:#111;color:#fff;cursor:pointer;">${escapeNewsletterHtml(this.modal.querySelector('.js-newsletter-coupon-apply')?.textContent.trim() || 'Kupon felhasználása')}</button>
        </div>
        <p data-newsletter-popup-feedback style="display:none;margin:14px 0 0;padding:12px;background:#e8f6ea;color:#2c7e3f;"></p>
      </div>
    `;

    document.body.appendChild(popup);
    this.popup = popup;
    popup.querySelector('[data-newsletter-popup-close]').addEventListener('click', () => this.closePopup());
    popup.querySelector('[data-newsletter-popup-copy]').addEventListener('click', async () => {
      await this.copyCouponCode();
      this.markClaimed('copied');
      this.setFeedback('A kuponkódot kimásoltuk.');
    });
    popup.querySelector('[data-newsletter-popup-apply]').addEventListener('click', async (event) => {
      await this.handleApplyCoupon(event);
    });
  }

  closePopup() {
    if (!this.popup) return;
    this.popup.remove();
    this.popup = null;
  }

  async copyCouponCode() {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(this.code);
      } catch (error) {}
    }
  }

  markClaimed(source) {
    if (!this.storageKey) return;

    try {
      window.localStorage.setItem(this.storageKey, JSON.stringify({
        claimedAt: new Date().toISOString(),
        source
      }));
    } catch (error) {}
  }

  setFeedback(message) {
    if (this.feedback) {
      this.feedback.textContent = message;
      this.feedback.hidden = false;
    }

    const popupFeedback = this.popup && this.popup.querySelector('[data-newsletter-popup-feedback]');
    if (popupFeedback) {
      popupFeedback.textContent = message;
      popupFeedback.style.display = 'block';
    }
  }

  async handleApplyCoupon(event) {
    event.preventDefault();

    try {
      const cart = await fetchNewsletterCouponCart();

      if (cart.item_count > 0) {
        this.markClaimed('applied');
        clearPendingNewsletterCoupon();
        window.location.href = this.discountUrl;
        return;
      }
    } catch (error) {
      this.markClaimed('applied');
      clearPendingNewsletterCoupon();
      window.location.href = this.discountUrl;
      return;
    }

    setPendingNewsletterCoupon({
      code: this.code,
      email: this.email,
      savedAt: new Date().toISOString()
    });
    this.markClaimed('saved_for_later');
    this.setFeedback(this.emptyCartFeedback);
  }
}

document.querySelectorAll('[data-newsletter-coupon-section]').forEach((section) => {
  new NewsletterCoupon(section);
});

document.addEventListener('on:cart:add', (event) => {
  activatePendingNewsletterCoupon(event.detail && event.detail.cart);
});

syncNewsletterReturnUrls();

renderNewsletterDebugBanner([
  `customer_posted=${shouldShowNewsletterDebugBanner()}`,
  `sections=${document.querySelectorAll('[data-newsletter-coupon-section]').length}`,
  `modals=${document.querySelectorAll('.js-newsletter-coupon-modal').length}`,
  `success_markers=${document.querySelectorAll('[data-newsletter-signup-success]').length}`,
  `coupon_code_present=${Boolean(document.querySelector('.js-newsletter-coupon-modal')?.dataset?.couponCode)}`,
  `email_present=${Boolean(document.querySelector('[data-newsletter-signup-success]')?.dataset?.newsletterEmail)}`
].join(' | '));
